var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal-card',{attrs:{"title":`File backup logs`,"processing":_vm.processing}},[_c('div',[(_vm.hasLogs)?_c('pre',[_vm._v(_vm._s(_vm.notes))]):_c('no-results',{staticStyle:{"margin":"auto"},attrs:{"title":"No logs","message":"There are no logs to show."}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }